module.exports = __webpack_public_path__ + "static/lafayette-dc7299bdff618dc03932b9d5a71030ed.jpg";